export default "__VITE_ASSET__C1qxB5YU__"